<template>
    <section aria-hidden="false" aria-labelledby="steps-uid-6-h-0" class="body current" id="steps-uid-6-p-0"
             role="tabpanel">
        <form>
            <div class="row">
                <div class="col-md-12">
                    <ul class="dd-list">
                        <li class="dd-item"><b>{{contract.type | capitalize}}</b> is created with partner <b>{{contract.partner.biz_name}}</b>
                            which expires on <b>{{contract.expires_at}}.</b></li>
                        <!--                        <li class="dd-item">The contract is created with <b>{{contract.quantity}} {{contract.goodsSerivces.unit.symbol}}</b> of <b>{{contract.goodsSerivces.name}}.</b></li>-->
                        <li class="dd-item" v-if="contract.items.length>0">The contract has following items
                            <ul class="dd-list">
                                <li class="dd-item" v-bind:key="index" v-for="(ct, index) in contract.items"><b>Goods/Service:</b>
                                    {{ct.good.name}}, <b>Quantity:</b> {{ct.quantity}}{{ct.good.unit.symobol}}, <b>Rate:</b>
                                    {{ct.rate}}
                                </li>
                            </ul>
                        </li>
                        <!--                        <li class="dd-item" v-if="contract.goodsSevicesProps[0].key!==null">Added Goods/Services has-->
                        <!--                            following specifications:-->
                        <!--                            <ul class="dd-list">-->
                        <!--                                <li class="dd-item" v-bind:key="index"-->
                        <!--                                    v-for="(gp, index) in contract.goodsSevicesProps"><b>{{gp.key | capitalize}}</b>:-->
                        <!--                                    {{gp.value}}-->
                        <!--                                </li>-->
                        <!--                            </ul>-->
                        <!--                        </li>-->
                        <!--                        <li class="dd-item" v-if="rate">The Pricing term method is <b>{{contract.pricingTerm.method.name}}</b>-->
                        <!--                            & the rate is <b>{{rate | money}}.</b></li>-->
                        <li class="dd-item">The contract amount is <b>{{contract.amount | money}}.</b></li>
                        <li class="dd-item">The contract has following payment terms:
                            <ul class="dd-list">
                                <li class="dd-item" v-bind:key="index" v-for="(cp, index) in contract.paymentTerms"><b>{{cp.type.name}}</b>
                                    payment term with amount <b>{{cp.amount |
                                        money}}</b> from <b>{{cp.effective_from}}</b> to <b>{{cp.due_at}}</b>
                                    and
                                    have to pay <span
                                            v-if="!cp.frequency"><b>One Time.</b></span><span v-else><b>{{cp.frequency.name}}</b> (No. of EMI: {{cp.no_of_emi}}).</span>
                                </li>
                            </ul>
                        </li>
                        <li class="dd-item" v-if="contract.attachments.length>0">The contract has following attachments
                            <ul class="dd-list">
                                <li class="dd-item" v-bind:key="index" v-for="(at, index) in contract.attachments"><b>{{at.title}}</b>
                                    ({{at.filename}})
                                </li>
                            </ul>
                        </li>
                    </ul>
                </div>
            </div>
        </form>
    </section>
</template>

<script>
    export default {
        name: "Summary",
        data() {
            return {
                rate: null,
                contract: this.$parent.contract
            }
        },
        mounted() {
        },
    }
</script>

<style scoped>

</style>
